/**
* Constants for Master actions.
* URL in these constants are having dynamic variables
* wrapped in {}, replace them with original dynamic variables
* in order to send API requests.
*/


/** Sales Hierarchy Configuration*/
export const SALE_HIERARCHY_CONFIGURATION =
  "/scheme-planning/ims/schemeplanlist?pageNo={currentPage}&pageSize={pageSize}&sortBy={value}{sortOrder}";

/** Sales Hierarchy Master*/
export const SALE_HIERARCHY_MASTER_DROPDOWN = "/sis-planning/ims/sis/master/role/config/master-data";
export const SALE_HIERARCHY_MASTER_SAVE = "/sis-planning/ims/sis/master/role/create";
export const SALE_HIERARCHY_MASTER_LIST =
"/sis-planning/ims/sis/master/role/list?pageNo={currentPage}&pageSize={pageSize}&sortBy={value}{sortOrder}";
export const SALE_HIERARCHY_MASTER_DELETE = "/sis-planning/ims/sis/master/role/delete?roleMasterId={roleMasterId}";

/** Sales Hierarchy Configuration*/
export const SALE_HIERARCHY_MASTER_CONFIGURATION_GEO_ELMENT =
  "/scheme-planning/ims/partnergroup/masterdata/geo?division={division}&channelIds={channelIds}";
export const SALE_HIERARCHY_MASTER_CONFIGURATION_LIST =
"/sis-planning/ims/sis/master/role/geo-config?pageNo={currentPage}&pageSize={pageSize}&sortBy={value}{sortOrder}";
export const SALE_HIERARCHY_MASTER_CONFIGURATION_SAVE = "/sis-planning/ims/sis/master/role/create-config-hdr?";
export const SALE_HIERARCHY_MASTER_CONFIGURATION_SUBMIT = "/sis-planning/ims/sis/master/role/submit?configId={configId}";
export const SALE_HIERARCHY_MASTER_CONFIGURATION_DELETE = "/sis-planning/ims/sis/master/role/delete-hdr?hdrId={roleMasterId}";

export const SALE_HIERARCHY_MASTER_CONFIGURATION_DTL_LINE_ITEM_LIST =
"/sis-planning/ims/sis/master/role/geo-config-dtl?pageNo={currentPage}&pageSize={pageSize}&sortBy={value}{sortOrder}&hdrId={hdrId}";
export const SALE_HIERARCHY_MASTER_CONFIGURATION_DTL_LINE_ITEM_SAVE = "/sis-planning/ims/sis/master/role/create-config-dtl?";
export const SALE_HIERARCHY_MASTER_CONFIGURATION_DTL_LINE_ITEM_DELETE = "/sis-planning/ims/sis/master/role/delete-dtl?dtlId={roleMasterId}";


/** Sales Hierarchy Configuration*/
export const SALE_HIERARCHY_MASTER_UPLOAD_LIST =
"/sis-planning/ims/sis/sales-hierarchy?pageNo={currentPage}&pageSize={pageSize}&sortBy={value}{sortOrder}";
export const SALE_HIERARCHY_MASTER_UPLOAD_SAVE = "/sis-planning/ims/sis/sales-hierarchy/create?";
export const SALE_HIERARCHY_MASTER_UPLOAD_DELETE = "/sis-planning/ims/sis/sales-hierarchy/delete?ids={ids}";

export const SALE_HIERARCHY_MASTER_UPLOAD_LINE_ITEM_LIST =
"/sis-planning/ims/sis/sales-hierarchy/party?&id={hdrId}";
export const SALE_HIERARCHY_MASTER_UPLOAD_LINE_ITEM_TEMPLATE_DOWNLOAD =
"/sis-planning/ims/sis/sales-hierarchy/download?id={hrdId}";

export const SALE_HIERARCHY_MASTER_UPLOAD_ROLE_INFO_LIST =
"/sis-planning/ims/sis/sales-hierarchy/roles?&id={id}";
export const SALE_HIERARCHY_MASTER_UPLOAD_ROLE_INFO_IMPORT_EXCEL =
"/sis-planning/ims/sis/sales-hierarchy/upload?&id={id}";
